import { Authorizer } from '../../model/authorizer';
import { Subject } from 'rxjs';
import { ObjectUtil } from '../ObjectUtil';

export class TableAuthorizerUser {

    static propCheck = 'checked';

    private elements: Array<Authorizer>;
    private elementSelecteds: Array<Authorizer>;
    public authorizerUsers = new Subject<Array<Authorizer>>();

    constructor() {
        this.elements = [];
    }

    OnInit() {
    }

    updateElement(el: any, obj: {}) {
        const indexElement = this.elements.indexOf(el);
        Object.assign(this.elements[indexElement], obj);
        this.authorizerUsers.next(this.elements);
    }

    updateElements(ev: any) {
        this.elements.forEach(el => Object.assign(el, ev));
        this.authorizerUsers.next(this.elements);
    }

    updateByElementId(ev: any) {
      this.elements.some(el => {
        if ((el.id) && (el.id === ev.id)) {
          Object.assign(el, ev);
        }
      });
    }

    getElementOptions(element): any {
        return { span: '', value: element[TableAuthorizerUser.propCheck] };
    }

    getElementSelected():  Array<Authorizer> {
      return this.elementSelecteds;
    }

    getList(filter) {
        this.authorizerUsers.next(this.elements.filter(item =>
            Object.keys(item).some(
                k =>
                    item[k] != null &&
                    item[k]
                        .toString()
                        .toLowerCase()
                        .includes(filter.toLowerCase())
            )
        ));
    }

    removeEl(user: Authorizer) {
        const index = this.elements.indexOf(user);
        this.elements.splice(index, 1);
        this.authorizerUsers.next(this.elements);
    }

    addEl(user: Authorizer) {
        this.elements.push(user);
        this.authorizerUsers.next(this.elements);
    }

    addList(users: Array<Authorizer>) {
        this.elements = Object.assign([], users);
        this.authorizerUsers.next(this.elements);
    }

    addListSelecteds(users: Array<Authorizer>) {
      this.elementSelecteds = Object.assign([], users);
      this.authorizerUsers.next(this.elementSelecteds);
    }

    mergeList(users: Array<Authorizer>) {
        let counter = 0;
        users.forEach(user => {
            const isNewUser = this.mergeById(user);
            if (isNewUser) {
                counter++;
            }
        });
        this.authorizerUsers.next(this.elements);
        return counter;
    }

    private mergeById(user: Authorizer) {
        let findUser;
        this.elements.some(el => {
            if ((el.id) && (el.id === user.id)) {
                findUser = Object.assign(el, user);
                return true;
            }
        });
        if ((!(findUser)) || ObjectUtil.isEmpty(findUser)) {
            this.elements.push(user);
            return true;
        }
        return false;
    }

    anyCheckedElement(): boolean {
        return this.elements.anyChecked(TableAuthorizerUser.propCheck);
    }

    countCheckedElements(): number {
        if(!this.elementSelecteds) {
            return 0;
        }
        return this.elementSelecteds.filter(el => el[TableAuthorizerUser.propCheck]).length;
    }

    deselectAll() {
        this.elementSelecteds = [];
        this.elements.forEach(el => el[TableAuthorizerUser.propCheck] = false);
        this.authorizerUsers.next(this.elements);
    }

    selectAll() {
        this.elementSelecteds = [];
        this.elements.forEach(el => el[TableAuthorizerUser.propCheck] = true);
        this.authorizerUsers.next(this.elements);
        this.elementSelecteds = this.elements.filter(el => el[TableAuthorizerUser.propCheck]);
    }

    contains(prop, value) {
        return this.elements.some(el => el[prop] == value);
    }

    changeElementPropertyValue(el, propName, propNewValue) {
        const indexElement = this.elements.indexOf(el);
        this.elements[indexElement][propName] = propNewValue;
        this.authorizerUsers.next(this.elements);
    }
}
